export const INSIGHTS_BASE_URL = '/insights';
export const INSIGHTS_HOME_DASHBOARD_URL = '/home';

export const HOME_DASHBOARD_CATEGORY = 'dashboard:landing';
export const USER_AND_TEAM_DASHBOARDS_CATEGORY = 'insights:dashboards';

export const LEGACY_LAYOUT_CATEGORY = 'insights:layout';
export const LAYOUTS_CATEGORY = 'insights/layouts';
export const WIDGETS_CATEGORY = 'insights/widgetBoard';

export const BOARD_KEY_TITLES: { [key: string]: string } = {
  home: 'Home Dashboard',
  user: 'Personal',
  team: 'Shared',
};

export const EMPTY_DEFAULT_LAYOUTS = { xs: [], sm: [], md: [], lg: [], xl: [] };
